/**
 * PHARMAKON — barcodes · GS1 mod-10 check digit (EAN-13, EAN-8, UPC-A, GTIN-14, Pharmakon lot codes).
 *
 * Weights 3, 1, 3, 1, … applied from the RIGHTMOST payload digit (GS1 General Specifications §7.9.1);
 * the check digit brings the weighted sum to the next multiple of ten.
 *
 * Canonical source: packages/shared/barcode/. The API image is built from apps/server alone, so
 * apps/server/src/utils/barcode/ holds a byte-identical copy (`npm run sync:barcode` in apps/server);
 * apps/server/src/__tests__/barcode.parity.test.js fails on any drift. Edit here, then sync.
 * This folder must stay dependency-free (relative imports inside the folder only).
 */

const CHIFFRES_RE = /^\d+$/;

/**
 * GS1 mod-10 check digit of a numeric payload.
 *
 * @param {string} payload digits only, at least one
 * @returns {number} 0…9
 */
export function cleGs1(payload) {
  if (typeof payload !== "string" || !CHIFFRES_RE.test(payload)) {
    throw new TypeError(`cleGs1 : chiffres uniquement (${String(payload)})`);
  }
  let somme = 0;
  for (let i = 0; i < payload.length; i += 1) {
    const chiffre = payload.charCodeAt(payload.length - 1 - i) - 48;
    somme += chiffre * (i % 2 === 0 ? 3 : 1);
  }
  return (10 - (somme % 10)) % 10;
}

/**
 * True when the last digit of `code` is the GS1 check digit of the others.
 *
 * @param {string} code digits only, at least two
 */
export function estCleGs1Valide(code) {
  if (typeof code !== "string" || code.length < 2 || !CHIFFRES_RE.test(code)) return false;
  return cleGs1(code.slice(0, -1)) === code.charCodeAt(code.length - 1) - 48;
}

/**
 * `payload` followed by its GS1 check digit.
 *
 * @param {string} payload digits only
 */
export function avecCleGs1(payload) {
  return `${payload}${cleGs1(payload)}`;
}
